// GA4 Analytics helpers — thin wrappers around gtag
const track = (event, params) => {
  if (window.gtag) window.gtag('event', event, params);
};

export const trackAddToCart = (name, price, category) => {
  track('add_to_cart', {
    currency: 'CAD',
    value: price,
    items: [{ item_name: name, price, item_category: category || 'Service' }],
  });
};

export const trackBeginCheckout = (items, total) => {
  track('begin_checkout', {
    currency: 'CAD',
    value: total,
    items: items.map(i => ({ item_name: i.name, price: i.price, quantity: 1 })),
  });
};

export const trackPurchase = (transactionId, total, items) => {
  track('purchase', {
    transaction_id: transactionId,
    currency: 'CAD',
    value: total,
    items: items.map(i => ({ item_name: i.name, price: i.price, quantity: 1 })),
  });
};

export const trackRebook = (services, date, therapist) => {
  track('rebook', {
    services: services.map(s => s.name).join(', '),
    date,
    therapist: therapist || 'Any',
  });
};

export const trackInStoreBooking = (services, total, therapist) => {
  track('in_store_booking', {
    currency: 'CAD',
    value: total,
    services: services.map(s => s.name).join(', '),
    therapist: therapist || 'Any',
  });
};

export const trackTrainingBooked = (serviceName, trainer, center) => {
  track('training_booked', {
    service_name: serviceName,
    trainer,
    center,
  });
};

export const trackCheckIn = (guestName, services, therapist) => {
  track('check_in', {
    guest_name: guestName,
    services: services.map(s => s.name).join(', '),
    therapist: therapist || '',
  });
};

export const trackPageView = (pageName) => {
  track('page_view', { page_title: pageName });
};
